import { render, staticRenderFns } from "./VerJornada.vue?vue&type=template&id=705a0e24&scoped=true"
import script from "./VerJornada.vue?vue&type=script&lang=js"
export * from "./VerJornada.vue?vue&type=script&lang=js"
import style0 from "./VerJornada.vue?vue&type=style&index=0&id=705a0e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a0e24",
  null
  
)

export default component.exports